// prettier-ignore
import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, OnChanges, SimpleChanges} from '@angular/core';
import { Projects } from '@usimweb/core/models';

@Component({
    selector: 'usimweb-card-bar',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './card-bar.component.html',
    styleUrls: ['./card-bar.component.scss'],
    standalone: false
})
export class CardBarComponent implements OnInit, OnChanges {
  @Input() user: string = '';

  @Input() project: Projects = {} as Projects;

  @Output() favouriteEventChanged: EventEmitter<any> = new EventEmitter<any>();

  @Output() openDialog: EventEmitter<any> = new EventEmitter<any>();

  @Output() updateSupportedEvent: EventEmitter<any> = new EventEmitter<any>();

  public showOptions = true;
  public isOwner = false;
  public isSupport = false;
  public peopleAmount = 0;
  // public projectName = '';

  public starMargin = '40px';
  public shareMargin = '80px';
  public people = 'person';
  public credits = 0;

  ngOnInit(): void {
    if (this.project.users) {
      this.peopleAmount = this.project.users.length - 1;
    }

    if (this.peopleAmount > 1) {
      this.people = 'people';
    }

    if (this.project.users) {
      this.isSupport = this.project.users.includes('support') ? true : false;
    }

    const created_by = this.project.created_by?.toLocaleLowerCase();
    this.credits = Math.round(this.project.credits.simulation || 0);
    // this.projectName = this.project.title !== undefined ? this.project.title : this.project.name;

    if (this.user === created_by) {
      this.isOwner = true;
    } else {
      this.showOptions = false;
      this.starMargin = '10px';
      this.shareMargin = '50px';
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.project && this.project.users && changes['project']) {
      this.peopleAmount = this.project.users.length - 1;
    }
  }

  public toggleFavourite(is_favorite: boolean) {
    this.project = { ...this.project, ['is_favorite']: is_favorite };
    this.favouriteEventChanged.emit(this.project);
  }

  public dialogEvent(event: any) {
    this.openDialog.emit(event);
  }

  public updateSupported(value: boolean) {
    this.updateSupportedEvent.emit(value);
  }

  public openShareDialog(uuid: string) {
    this.openDialog.emit({ event: 'share', uuid: uuid, data: this.project });
  }

  public get simAmount() {
    if (this.project.status) {
      return (
        this.project.status.success +
        this.project.status.processing +
        this.project.status.failed +
        this.project.status.waiting
      );
    }
    return 0;
  }
}
